export default "__VITE_ASSET__Co52omGZ__"